/* eslint-disable sort-keys */
import {useTranslation} from 'react-i18next'

export const useNativeTranslation = () => {
    const {t} = useTranslation()

    return {
        t: {
            imageSaved: t('Image saved to Download folder'),
            Success: t('Success'),
            DownloadFailed: t('Download Failed'),
            FilenameIsMissing: t('Filename is missing'),
            StoragePermission: t('Storage Permission'),
            AppNeedsAccessToStorageToDownloadImages: t('App needs access to storage to download images'),
            OK: t('OK'),
            PermissionDenied: t('Permission Denied'),
            CannotDownloadWithoutStoragePermission: t('Cannot download without storage permission'),
        },
    } as const
}
